import { render, staticRenderFns } from "./vip-level.vue?vue&type=template&id=1faabfbc&scoped=true"
import script from "./vip-level.vue?vue&type=script&lang=js"
export * from "./vip-level.vue?vue&type=script&lang=js"
import style0 from "./vip-level.vue?vue&type=style&index=0&id=1faabfbc&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faabfbc",
  null
  
)

export default component.exports